function Hora({ date, hour_data, temperature, text, icon, wind, wind_direction, icon_wind, pressure, humidity }) {


        const icono = 'https://v5i.tutiempo.net/wi/01/50/' + icon + '.png'
        const icono_viento = 'https://v5i.tutiempo.net/wd/big/black/' + icon_wind + '.png'
        
        let today = new Date()
        const diaActual =   today.getFullYear() + '-' + parseInt(today.getMonth() + 1) + '-' + today.getDate()
//console.log(today.getHours())
        let span = null
        if (diaActual === date && today.getHours()+':00'===hour_data) {
                span = (
                        <><span className="badge bg-danger rounded-pill">AHORA</span><br></br></>
                )
        } else if (diaActual !== date && hour_data === '0:00') {
                span = (
                        <><span className="badge bg-danger rounded-pill">MAÑANA</span><br></br></>
                )
        } else {
                span=(
                        <span><strong>{hour_data}</strong> | <br></br></span>
                )
        }
        return (
                <div className="horadata">
                        <p className="time">{span}
                        {text}</p>
                        <p className="wind"><img alt={text} title={text} height="40" src={icono} width="40" />{temperature}&deg;C</p>
                        <p className="wind"><img alt={wind_direction} title={wind_direction} height="35" src={icono_viento} width="35" />{wind}km/h</p>
                        <p className="oc subrra">Humedad: {humidity}%<br />Presión: {pressure}hPa</p>
                </div>
        )


}
export default Hora;